var _circle, _circle2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEqRefrigerated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 18,
    r: 2.5,
    stroke: "#3F3F3F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 18,
    r: 2.5,
    stroke: "#3F3F3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 20.5C21.2761 20.5 21.5 20.2761 21.5 20C21.5 19.7239 21.2761 19.5 21 19.5V20.5ZM18 19.5C17.7239 19.5 17.5 19.7239 17.5 20C17.5 20.2761 17.7239 20.5 18 20.5V19.5ZM19.0882 17V20H20.0882V17H19.0882ZM19.5882 20.5H21V19.5H19.5882V20.5ZM19.5882 19.5H18V20.5H19.5882V19.5Z",
    fill: "#3F3F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8H17.6533M17.6533 8L19.2533 6.5M17.6533 8H20M17.6533 8L19.2533 9.5M16.0533 4V12M12.8533 6.5L14.4533 8L12.8533 9.5M17.6533 5L16.0533 6.5L14.4533 5M14.4533 11L16.0533 9.5L17.6533 11",
    stroke: "#3F3F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.917 7H22C22.5523 7 23 7.44772 23 8V15C23 15.5523 22.5523 16 22 16H13.2361C13.4944 16.2885 13.6976 16.6274 13.8293 17H22C23.1046 17 24 16.1046 24 15V8C24 6.89543 23.1046 6 22 6H21.6586C21.7723 6.32163 21.8593 6.65585 21.917 7ZM10.3414 6H2C0.895431 6 0 6.89543 0 8V15C0 16.1046 0.89543 17 2 17H2.17071C2.30241 16.6274 2.50564 16.2885 2.76389 16H2C1.44772 16 1 15.5523 1 15V8C1 7.44772 1.44772 7 2 7H10.083C10.1407 6.65585 10.2277 6.32163 10.3414 6ZM7.82929 17C7.69759 16.6274 7.49436 16.2885 7.23611 16H8.76389C8.50564 16.2885 8.30241 16.6274 8.17071 17H7.82929Z",
    fill: "#3F3F3F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqRefrigerated);
export default __webpack_public_path__ + "static/media/eq-refrigerated.b4b35660c85c51b08f047c2a067629ec.svg";
export { ForwardRef as ReactComponent };